/* eslint-disable consistent-return */
/* eslint-disable no-useless-escape */
/* eslint-disable no-plusplus */
const HTML_MIME_TYPE = 'text/html';

export const VALID_HTML_ELEMENTS = [
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'UL',
  'OL',
  'LI',
  'DI',
  'STRONG',
  'B',
  'I',
  'DIV',
  'P',
  'SPAN',
  'BR',
  'HR',
  'A',
  'FOOTER',
  'STYLE',
];
export const VALID_ATTRIBUTES = [
  'target',
  'id',
  'href',
  'class',
  'itemprop',
  'itemtype',
];

// attribute name matcher. Enforces well structured attribute names. Otherwise teh node is deleted to avoid wonkyness.
// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
// prettymuch standard letters, numbers, dashes and :
const ATTRUBUTE_NAME_REGEX = /^[a-z0-9\.\-\:]*$/i;

let n = 0;

export function getSafeHtml(html: string): string {
  // don't use the global counter during unit tests
  const id =
    process.env.NODE_ENV === 'test'
      ? 'safeHtmlWrapper'
      : `safeHtmlWrapper${n++}`;
  // add divs for text elements to ensure that there is always a root element
  const dom = new DOMParser().parseFromString(
    `<div id="${id}">${html}</div>`,
    HTML_MIME_TYPE
  );
  const sanitized = sanitizeNodeTree(dom.querySelector(`#${id}`));
  const output = new XMLSerializer().serializeToString(
    sanitized as HTMLElement
  );
  return output;
}

export function sanitizeNodeTree(node: HTMLElement): HTMLElement | undefined {
  // text
  if (!node.setAttribute) {
    return;
  }

  for (let x = 0; x < node.attributes.length; x++) {
    // remove invalid HTML attributes
    if (!ATTRUBUTE_NAME_REGEX.test(node.attributes.item(x).nodeName)) {
      (node.parentNode as HTMLElement).removeChild(node);
      return;
    }

    if (VALID_ATTRIBUTES.indexOf(node.attributes.item(x).nodeName) === -1) {
      node.setAttribute(node.attributes.item(x).nodeName, '');
    }
  }

  if (node.tagName && VALID_HTML_ELEMENTS.indexOf(node.tagName) === -1) {
    (node.parentNode as HTMLElement).removeChild(node);
    return;
  }

  if (node.childNodes) {
    for (let x = 0; x < node.childNodes.length; x++) {
      sanitizeNodeTree(node.childNodes.item(x) as HTMLElement);
    }
  }

  return node;
}
